import { useParams } from 'react-router'

import { TikTokListDetailsView } from '@/modules/tiktok-research/lists/views/TikTokListDetailsView.tsx'

export const TikTokListDetails = () => {
  const { id } = useParams<{ id: string }>()

  if (!id) {
    return null
  }

  return <TikTokListDetailsView listId={id} />
}
